import React from "react";
import RecipeDifficultyTag from "../RecipeDifficultyTag/RecipeDifficultyTag";
import RecipeRegimeTag from "../RecipeRegimeTag/RecipeRegimeTag";
import RecipeSeasonTag from "../RecipeSeasonTag/RecipeSeasonTag";

export default function Recipe({
  imageUrl,
  tags,
  title,
  difficulty,
  duration,
  regimeTags
}) {
  return (
    <div className="recipe_card_container">
      <img src={imageUrl} />
      <div className="recipe_card_desc_container">
        <div className="recipe_card_desc_info_container">
          <p className="recipe_card_title">{title}</p>
          <p className="recipe_card_duration">{duration}</p>
        </div>
        <div className="recipe_card_tags_container">
          <div className="recipe_card_difficulty_tags_container">
            <RecipeDifficultyTag difficulty={difficulty} />
          </div>
          <div className="recipe_card_regime_tags_container">
            {regimeTags.map((tag, i) => {
              return (
                <RecipeRegimeTag key={i} regime={tag?.attributes?.name} />
              )
            })}
          </div>
        </div>
        <div className="recipe_card_season_tags_container">
          {tags.map((tag, i) => {
            return (
              <RecipeSeasonTag key={i} season={tag?.attributes?.name} />
            )
          })}
        </div>
      </div>
    </div>
  );
}
